import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import useSpaceBaseQueryBaseQuery, {
	type useSpaceBaseQueryBaseQuery$data,
	type useSpaceBaseQueryBaseQuery$variables,
} from './__generated__/useSpaceBaseQueryBaseQuery.graphql.ts';

export function preloadSpace(spaceKey: useSpaceBaseQueryBaseQuery$variables['spaceKey']) {
	return query<useSpaceBaseQueryBaseQuery$data, useSpaceBaseQueryBaseQuery$variables>({
		query: useSpaceBaseQueryBaseQuery,
		variables: {
			spaceKey,
		},
	});
}
